import { render, staticRenderFns } from "./labelConfiguration.vue?vue&type=template&id=08777c19&scoped=true&"
import script from "./labelConfiguration.vue?vue&type=script&lang=js&"
export * from "./labelConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./labelConfiguration.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./labelConfiguration.vue?vue&type=style&index=1&id=08777c19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08777c19",
  null
  
)

component.options.__file = "labelConfiguration.vue"
export default component.exports